import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    name: 'Login',
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: () => import('@/views/dashboard/index.vue'), name: 'Dashboard', meta: { title: '首页' } },
      { path: 'house/stats', component: () => import('@/views/house/stats.vue'), name: 'HouseStats', meta: { title: '房屋出租管理' } },
      { path: 'house/list', component: () => import('@/views/house/list.vue'), name: 'HouseList', meta: { title: '房产列表' } },
      { path: 'house/detail/:id', component: () => import('@/views/house/detail.vue'), name: 'HouseDetail', meta: { title: '房产详情' } },
      { path: 'house/edit/:id', component: () => import('@/views/house/edit.vue'), name: 'HouseEdit', meta: { title: '编辑房产' } },
      { path: 'house/tenant', component: () => import('@/views/house/tenant.vue'), name: 'Tenant', meta: { title: '租赁人员' } },
      { path: 'house/tenant-detail/:id', component: () => import('@/views/house/tenant-detail.vue'), name: 'TenantDetail', meta: { title: '租户详情' } },
      { path: 'house/tenant-edit/:id', component: () => import('@/views/house/tenant-edit.vue'), name: 'TenantEdit', meta: { title: '编辑租户' } },
      { path: 'house/contract', component: () => import('@/views/house/contract.vue'), name: 'Contract', meta: { title: '合同录入' } },
      { path: 'house/contract-detail/:id', component: () => import('@/views/house/contract-detail.vue'), name: 'ContractDetail', meta: { title: '合同详情' } },
      { path: 'house/contract-edit/:id', component: () => import('@/views/house/contract-edit.vue'), name: 'ContractEdit', meta: { title: '编辑合同' } },
      { path: 'house/exception-detail/:id', component: () => import('@/views/house/exception-detail.vue'), name: 'ExceptionDetail', meta: { title: '异常记录详情' } },
      { path: 'house/exception-edit/:id', component: () => import('@/views/house/exception-edit.vue'), name: 'ExceptionEdit', meta: { title: '修改异常数据' } },
      { path: 'ai/chat', component: () => import('@/views/ai/chat.vue'), name: 'AiChat', meta: { title: 'AI智能问答' } },
      { path: 'attendance/list', component: () => import('@/views/attendance/list.vue'), name: 'AttendanceList', meta: { title: '考勤统计' } },
      { path: 'attendance/record', component: () => import('@/views/attendance/record.vue'), name: 'AttendanceRecord', meta: { title: '考勤录入' } },
      { path: 'leave-management', component: () => import('@/views/leave-management/index.vue'), name: 'LeaveManagement', meta: { title: '请假信息管理' } },
      { path: 'canteen/compare', component: () => import('@/views/canteen/compare.vue'), name: 'PriceCompare', meta: { title: '价格比对' } },
      { path: 'canteen/price', component: () => import('@/views/canteen/price.vue'), name: 'Price', meta: { title: '价格录入' } },
      { path: 'canteen/market', component: () => import('@/views/canteen/market.vue'), name: 'MarketPrice', meta: { title: '民生商品价格' } },
      { path: 'system/user', component: () => import('@/views/system/user.vue'), name: 'User', meta: { title: '用户管理', requireAdmin: true } },
      { path: 'system/permission', component: () => import('@/views/system/permission.vue'), name: 'Permission', meta: { title: '权限管理', requireAdmin: true } },
      { path: 'print-business/entry', component: () => import('@/views/print-business/entry.vue'), name: 'PrintBusinessEntry', meta: { title: '经营成本录入' } },
      { path: 'print-business/stats', component: () => import('@/views/print-business/stats.vue'), name: 'PrintBusinessStats', meta: { title: '统计分析' } },
      { path: 'profile', component: () => import('@/views/profile/index.vue'), name: 'Profile', meta: { title: '个人中心' } }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 信息管理系统'
  }
  
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (!token) {
      next('/login')
    } else {
      if (to.meta.requireAdmin) {
        try {
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
          if (userInfo.role !== '超级管理员') {
            ElMessage.error('您没有权限访问此页面')
            next('/dashboard')
            return
          }
        } catch {
          ElMessage.error('用户信息异常')
          next('/login')
          return
        }
      }
      next()
    }
  }
})

export default router